import { faCircleQuestion } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { IconButton } from '@/components/shared/IconButton';
import { IntercomConsentDialog } from '@/components/shared/IntercomConsentDialog';
import { useTranslator } from '@/hooks/useTranslator';
import {
  acceptIntercomConsent,
  hasIntercomConsent,
  setIntercomLauncherVisible,
  showIntercomChat,
} from '@/lib/utils/intercom';
import { setIntercomLauncherDismissed } from '@/lib/utils/intercomLauncherState';
import { useSessionStore } from '@/store/sessionStore';

/**
 * Opens the support chat, asking for cookie consent first if it has not been
 * granted. Owns that dialog, so an area that offers no support chat renders
 * neither.
 */
export function AppHeaderHelpButton() {
  const { getTranslation } = useTranslator({ page: 'appHeader' });
  const user = useSessionStore(s => s.user);
  const [consentOpen, setConsentOpen] = useState(false);

  return (
    <>
      <IconButton
        variant='ghost'
        size='icon'
        className='h-7.5 w-7.5 text-muted-foreground'
        tooltip={getTranslation('help')}
        data-tour='help'
        onClick={() => {
          if (!hasIntercomConsent()) {
            setConsentOpen(true);
            return;
          }
          // Also the way back: if the user closed the bubble, opening chat from
          // here restores it — otherwise dismissing it would be a one-way door.
          setIntercomLauncherDismissed(false);
          // Clearing our own flag is not enough — Intercom keeps its own
          // `hide_default_launcher` state, so tell it directly too.
          setIntercomLauncherVisible(true);
          showIntercomChat();
        }}
      >
        <FontAwesomeIcon icon={faCircleQuestion} className='text-sm' />
      </IconButton>

      <IntercomConsentDialog
        open={consentOpen}
        onOpenChange={setConsentOpen}
        onAccept={() => {
          acceptIntercomConsent(user);
          setConsentOpen(false);
          showIntercomChat();
        }}
      />
    </>
  );
}
